import { get } from "./Api_helper";
import { VYLABS_BASE_URL, GET_CHAT_MESSAGES_LIST_URL } from "./url_helper";

// Shown in the chat bubble when the answer could not be delivered live and the
// REST recovery also could not retrieve it. The answer is still persisted, so we
// point the user to where they can find it.
export const RECOVERY_FAILED_MESSAGE =
  "Hmm, I couldn't show the reply here, but don't worry — it's saved in your " +
  "Conversations. Open Conversations to view it, or try again later.";

// Fetches the most recent stored message for a chat channel and returns the bot
// answer text ONLY if that latest message is a bot reply (sender_id ===
// channelID). If the latest message is the user's question, the answer has not
// been persisted yet, so we return null — this prevents the recovery path from
// ever showing a stale (previous-turn) answer while the current one is still
// being generated.
export const fetchLatestAnswerIfReady = async (channelID) => {
  if (!channelID || channelID === "null" || channelID === "undefined") {
    return null;
  }
  const response = await get(
    VYLABS_BASE_URL,
    `${GET_CHAT_MESSAGES_LIST_URL}?chatChannelID=${channelID}&offset=0&limit=5`,
  );
  const messages = response?.chat_messages || [];
  if (messages.length === 0) return null;

  const latest = [...messages].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  )[0];
  // Bot replies are stored with sender_id equal to the channel id.
  if (!latest || latest.sender_id !== channelID) return null;

  try {
    const parsed = JSON.parse(latest.content || "{}");
    const answer = parsed.answer;
    return typeof answer === "string" && answer.trim() ? answer : null;
  } catch (err) {
    return null;
  }
};
